import { DEFAULT_CHART_DOWNLOAD_FILENAME } from "../constants";

const MAX_FILENAME_LENGTH = 80;

export const sanitizeChartDownloadFileName = (...parts: (string | undefined)[]): string => {
  const raw = parts
    .filter((part): part is string => Boolean(part?.trim()))
    .join("-")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

  if (!raw) {
    return DEFAULT_CHART_DOWNLOAD_FILENAME;
  }

  return raw.slice(0, MAX_FILENAME_LENGTH);
};
